import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  deviceGroups: [],
  error: false,
  apiNotFound: false,
  success: false,
  loading: false,
  loaded: false,
  createDeviceGroupError: false,
  createDeviceGroupSuccess: false,
  createDeviceGroupLoading: false,
  createDeviceGroupLoaded: false,
  deleteGroupLoading: false,
  deleteGroupSuceess: false,
  deleteGropuFailed: false,
  unassignDeviceGroupLoading: false,
  unassignDeviceGroupSuccess: false,
  unassignDeviceGroupFailed: false,
  pauseDeviceGroupError: false,
  pauseDeviceGroupSuccess: false,
};
const resetDeviceGroupsState = (state, action) => {
  return updateObject(state, initialState)
}
const initDeviceGroupsStart = (state, action) => {
  return updateObject(state, {
    // error: null,
    loading: true,
    loaded: false,
    apiNotFound: false
  });
};

const setDeviceGroups = (state, action) => {
  //console.log("setDeviceGroups reducers", state, action);
  return updateObject(state, {
    deviceGroups: Array.isArray(action.deviceGroups) ? action.deviceGroups : [],
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchDeviceGroupsFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    loaded: true,
    error: false,
    apiNotFound: true
  });
};

const createDeviceGroupStart = (state, action) => {
  return updateObject(state, {
    createDeviceGroupError: null,
    createDeviceGroupLoading: true,
    createDeviceGroupLoaded: false
  });
};

const createDeviceGroupFailed = (state, action) => {
  return updateObject(state, {
    createDeviceGroupLoading: false,
    createDeviceGroupLoaded: true,
    createDeviceGroupError: true,
    createDeviceGroupSuccess: false
  });
};

const createDeviceGroupSuccess = (state, action) => {
  //console.log('createDeviceGroupSuccess reducers', action);
  return updateObject(state, {
    createDeviceGroupLoading: false,
    createDeviceGroupLoaded: true,
    createDeviceGroupError: false,
    createDeviceGroupSuccess: true
  });
};

const resetCreateDeviceGroupSuccessError = (state, action) => {
  //console.log('resetCreateDeviceGroupSuccessError reducers', action);
  return updateObject(state, {
    createDeviceGroupError: false,
    createDeviceGroupSuccess: false
  });
};

const resetPauseDeviceGroupSuccessError = (state, action) => {
  //console.log('resetCreateDeviceGroupSuccessError reducers', action);
  return updateObject(state, {
    pauseDeviceGroupError: false,
    pauseDeviceGroupSuccess: false,
    error: false,
    success: false

  });
};

const getDevicesFromGroupStart = (state, action) => {
  return updateObject(state, {
    getDevicesFromGroupError: null,
    getDevicesFromGroupLoading: true,
    getDevicesFromGroupLoaded: false
  });
};

const getDevicesFromGroupFailed = (state, action) => {
  return updateObject(state, {
    getDevicesFromGroupLoading: true,
    getDevicesFromGroupLoaded: false,
    getDevicesFromGroupError: true
  });
};

const setDeleteGroupSuccess = (state, action) => {
  return updateObject(state, {
    success: true,
    error: false
  });
};

const setDeleteGroupFailure = (state, action) => {
  return updateObject(state, {
    success: false,
    error: true
  })
};

const setChangeDevicesGroupSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    success: true
  });
};

const setChangeDevicesGroupFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: true
  });
};

const setPauseDeviceGroupSuccess = (state, action) => {
  return updateObject(state, {
    pauseDeviceGroupLoading: false,
    pauseDeviceGroupSuccess: true,
    success: true,
    error: false
  });
};

const setPauseDeviceGroupFailed = (state, action) => {
  return updateObject(state, {
    pauseDeviceGroupLoading: false,
    // pauseDeviceGroupError: true,
    sucess: false,
    error: true
  });
};

const resetGroupsErrorSuccess = (state, action) => {
  return updateObject(state, {
    pauseDeviceGroupLoading: false,
    pauseDeviceGroupError: false,
    pauseDeviceGroupSuccess: false
  })
}
const setUnassignedDeviceGroupsSuccess = (state, action) => {
  return updateObject(state, {
    success: true,
    error: false
  });
};

const setUnassignedDeviceGroupsFailed = (state, action) => {
  return updateObject(state, {
    error: true,
    success: false
  })
};

const resetgroupDeviceSuccessError = (state, action) => {
  return updateObject(state, {
    success: false,
    error: false
  });
}

const setFreezeDeviceGroupFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: true
  });
}
const setFreezeDeviceGroupSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    success: true
  });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_DEVICE_GROUPS_START:
      return initDeviceGroupsStart(state, action);
    case actionTypes.SET_DEVICE_GROUPS:
      return setDeviceGroups(state, action);
    case actionTypes.FETCH_DEVICE_GROUPS_FAILED:
      return fetchDeviceGroupsFailed(state, action);
    case actionTypes.CREATE_DEVICE_GROUP_START:
      return createDeviceGroupStart(state, action);
    case actionTypes.CREATE_DEVICE_GROUP_FAILED:
      return createDeviceGroupFailed(state, action);
    case actionTypes.CREATE_DEVICE_GROUP_SUCCESS:
      return createDeviceGroupSuccess(state, action);
    case actionTypes.RESET_CREATE_DEVICE_GROUP_SUCCESS_ERROR:
      return resetCreateDeviceGroupSuccessError(state, action);
    case actionTypes.RESET_PAUSE_DEVICE_GROUP_SUCCESS_ERROR:
      return resetPauseDeviceGroupSuccessError(state, action);
    case actionTypes.GET_DEVICES_FROM_GROUP_START:
      return getDevicesFromGroupStart(state, action);
    case actionTypes.GET_DEVICES_FROM_GROUP_FAILED:
      return getDevicesFromGroupFailed(state, action);
    case actionTypes.RESET_GROUPS_ERROR_SUCCESS:
      return resetGroupsErrorSuccess(state, action);
    case actionTypes.DELETE_GROUPS_SUCCESS:
      return setDeleteGroupSuccess(state, action);
    case actionTypes.DELETE_GROUPS_FAILED:
      return setDeleteGroupFailure(state, action);
    case actionTypes.UNASSIGN_DEVICE_GROUPS_FAILED:
      return setUnassignedDeviceGroupsFailed(state, action);
    case actionTypes.UNASSIGN_DEVICE_GROUPS_SUCCESS:
      return setUnassignedDeviceGroupsSuccess(state, action);
    case actionTypes.CHANGE_DEVICES_GROUP_SUCCESS:
      return setChangeDevicesGroupSuccess(state, action);
    case actionTypes.CHANGE_DEVICES_GROUP_FAILED:
      return setChangeDevicesGroupFailed(state, action);
    case actionTypes.PAUSE_DEVICE_GROUP_SUCCESS:
      return setPauseDeviceGroupSuccess(state, action);
    case actionTypes.PAUSE_DEVICE_GROUP_FAILED:
      return setPauseDeviceGroupFailed(state, action);
    case actionTypes.RESET_GROUP_DEVICE_SUCCESS_ERROR:
      return resetgroupDeviceSuccessError(state, action);
    case actionTypes.FREEZE_DEVICE_GROUP_FAILED:
      return setFreezeDeviceGroupFailed(state, action);
    case actionTypes.FREEZE_DEVICE_GROUP_SUCCESS:
      return setFreezeDeviceGroupSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;

